// Nav type
export type navLinkType = {
  label: string;
  url: string;
};

// Nav
const navLinks = [
  {
    label: 'GGR Advantage',
    url: '#services',
  },
  {
    label: 'Loyalty Engine',
    url: '#works',
  },
  {
    label: 'Partner Program',
    url: '#about-me-section',
  },
  {
    label: 'Testimonials',
    url: '#testimonials-section',
  },
  {
    label: 'Partner Login',
    url: '#contact-section',
  },
];
const navbarLinks = [
  {
    label: 'Home',
    url: '#app',
  },
  ...navLinks,
];

const socialLinks = [
  {
    label: 'X',
    url: 'https://x.com/cashflowcasino',
  },
  {
    label: 'Telegram',
    url: 'https://t.me/cashflowcasino',
  },
  {
    label: 'GitHub',
    url: 'https://github.com/cashflow-casino',
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/company/cashflow-casino/',
  },
];

const resourceLinks = [
  {
    label: 'Operator Guide',
    url: '/docs/operator-guide',
  },
  {
    label: 'Integration API',
    url: '/docs/api',
  },
];

const heroText =
  'Launch your online casino platform with zero upfront costs. We provide the bank. You pay a week behind.';

const locationPlace = `Positive Cash Flow`;
const locationCountry = 'From Day One';

// cal.com (Keeping these for now, might be repurposed later or removed)
const dataCalNamespace = '30min';
const dataCalLink = 'brhoom/30min';
const dataCalConfig =
  '{"layout":"month_view", "theme": "dark", "brand": "#6236ff"}';

export {
  socialLinks,
  resourceLinks,
  heroText,
  locationPlace,
  locationCountry,
  navLinks,
  navbarLinks,
  dataCalNamespace,
  dataCalLink,
  dataCalConfig,
};
